import { render, staticRenderFns } from "./settingCompanyClassifications.vue?vue&type=template&id=30a2b0f8&scoped=true&"
import script from "./settingCompanyClassifications.vue?vue&type=script&lang=js&"
export * from "./settingCompanyClassifications.vue?vue&type=script&lang=js&"
import style0 from "./settingCompanyClassifications.vue?vue&type=style&index=0&id=30a2b0f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a2b0f8",
  null
  
)

export default component.exports